const sectionCode = "SPRO2";
const chartCode = "C014x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T14Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T14Procedures };
